import React from 'react';
import { createRoot } from 'react-dom/client';
import '../styles.css';
import './features/fleet/owner-fleet.css';
import './features/bookings/owner-calendar.css';
import './features/payments/payment-checkout.css';
import './features/crm/owner-crm.css';
import './features/team/stage7.css';
import './features/finance/owner-finance.css';
import './features/service/owner-service.css';
import './features/marketing/owner-marketing.css';
import './features/analytics/owner-analytics.css';
import './features/analytics/owner-nav-visibility.css';
import './review-polish.css';
import { App } from './app/App';
import { installTelegramContactAutofill } from './integrations/telegram/contactAutofill';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('React root not found');

installTelegramContactAutofill();

createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
